import React from 'react';
import styled from 'styled-components';
import { BannerDto } from '../types';
import {
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody
} from './common/modal/ModalComponents';
import Modal from './common/modal/Modal';

const BannerDetailContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 1.5rem;
`;

const DetailTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 800;
  color: #2d3748;
  margin-bottom: 1rem;
`;

const DetailDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #4a5568;
  white-space: pre-wrap;
`;

const CloseIconButton = styled(CloseButton)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 10;
`;

interface BannerDetailModalProps {
  banner: BannerDto | null;
  onClose: () => void;
}

const BannerDetailModal: React.FC<BannerDetailModalProps> = ({ banner, onClose }) => {
  if (!banner) return null;

  return (
    <Modal isOpen={!!banner} onClose={onClose} maxWidth="600px" noPadding>
        <CloseIconButton onClick={onClose}>&times;</CloseIconButton>
        <ModalBody padding="0">
          <BannerDetailContent>
            <DetailImage src={banner.imageUrl} alt={banner.title} />
            <div style={{ padding: '0 2rem 2rem 2rem' }}>
              <DetailTitle>{banner.title}</DetailTitle>
              <DetailDescription>{banner.description}</DetailDescription>
            </div>
          </BannerDetailContent>
        </ModalBody>
    </Modal>
  );
};

export default BannerDetailModal;
